var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.553 6h15.555A7.892 7.892 0 0 1 36 13.892v0a7.892 7.892 0 0 1-7.892 7.893h-19.5A5.608 5.608 0 0 0 3 27.392v0A5.608 5.608 0 0 0 8.608 33h20.155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.12e86c1305de13e5cb31251c3a251b39.svg";
export { ForwardRef as ReactComponent };